import { http } from '@/http/axios.js'
// 存储storage
export function getStorageDetailAPI(key) {
  return http({
    url: '/api/admin/setting/getSetting',
    method: 'get',
    params: { key }
  })
}
export function saveStorageAPI(data) {
  return http({
    url: '/api/admin/setting/setting',
    method: 'post',
    data
  })
}
// 站点site
export function getSiteDetailAPI() {
  return http({
    url: '/api/admin/site/detail',
    method: 'get'
  })
}
export function saveSiteAPI(data) {
  return http({
    url: '/api/admin/site/setting',
    method: 'post',
    data
  })
}
